<template>
  <div class="core-values">
    <div class="values-content">
      <div class="top-right-box">
        <div class="tit-eh">FOCUS ON INNOVATION AND SERVICE FIRST</div>
        <div class="tit-zh">华跃 专注创新，服务至上</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ValuesView',
};
</script>

<style lang="less" scoped>
.core-values{
  width: 1200px;
  margin: 0 auto;
  padding: 80px 0 60px;
  border-top: 2px solid #e8ecf3;
  .values-content{
    width: 100%;
    height: 500px;
    padding: 0 69px;
    position: relative;
    background: url('@/assets/about/values/values-back.png') no-repeat;
    background-size: cover;
    background-position: center;
    box-sizing: border-box;
    .top-right-box{
      width: 740px;
      height: 200px;
      position: absolute;
      top: 0;
      right: 0;
      background: url('@/assets/about/values/top-right-back.png') no-repeat;
      background-size: cover;
      background-position: center;
      transform: translateY(-50px);
      padding: 0 30px;
      .tit-eh{
        width: 520px;
        font-family: OPPOSans-M;
        font-size: 35px;
        color: #b3c9e5;
        margin-top: 40px;
        line-height: 38px;
      }
      .tit-zh{
        margin-top: 12px;
        line-height: 1;
        font-size: 18px;
        font-family: OPPOSans-M;
        color: #00b0dc;
      }
    }
  }
}
</style>
